import { render, staticRenderFns } from "./BookingPositionInboxCard.vue?vue&type=template&id=6109e04a&"
import script from "./BookingPositionInboxCard.vue?vue&type=script&lang=js&"
export * from "./BookingPositionInboxCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionInboxCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports